<p class="goal-desc">Offer discounts to carts that have these values</p>

@if (goal.controls.thresholds.controls.length) {
  <div class="threshold-list">
    <div class="threshold-row threshold-row--head">
      <span class="threshold-head threshold-row__country">Select country</span>
      <span class="threshold-head threshold-row__value">
        {{ minimumThresholdType.value === 'item_count' ? 'Item count' : 'Threshold' }}
      </span>
      @if (minimumThresholdType.value !== 'item_count') {
        <span class="threshold-head threshold-row__currency">Currency</span>
      }
      <span class="threshold-row__remove"></span>
    </div>

    @for (thresholdCtrl of goal.controls.thresholds.controls; track thresholdCtrl; let tIndex = $index) {
      <div class="threshold-row">
        <country-and-states-dropdown
          class="threshold-row__country"
          [hideStates]="true"
          [control]="thresholdCtrl.controls.countriesAndRegions"></country-and-states-dropdown>
        <pdq-input-arrows
          class="threshold-row__value"
          [formControl]="thresholdCtrl.controls.threshold"
          [min]="0"
          [precision]="minimumThresholdType.value === 'cart_value' ? 2 : 0"
          [step]="minimumThresholdType.value === 'cart_value' ? 0.01 : 1"
          [required]="false"></pdq-input-arrows>
        @if (minimumThresholdType.value !== 'item_count') {
          <pdq-dropdown
            class="threshold-row__currency"
            [formControl]="thresholdCtrl.controls.currency"
            [options]="currencyCodes | primitiveDropdownOptionsPipe"></pdq-dropdown>
        }
        <pdq-button
          class="threshold-row__remove"
          icon="close"
          variant="ghost"
          plain="true"
          size="medium"
          iconColor="var(--on-surface-light)"
          (onClick)="removeThreshold(tIndex)"></pdq-button>
      </div>
      @if (thresholdErrors?.[index + '-' + tIndex]; as thresholdError) {
        <span class="threshold-error">{{ thresholdError }}</span>
      }
    }
  </div>
}

<pdq-button
  class="add-threshold"
  variant="secondary"
  size="small"
  icon="Plus"
  label="Add threshold"
  (onClick)="addThreshold()"></pdq-button>

<div class="field">
  <div class="message-header">
    <span class="field__label message-header__label">Message Displayed When Goal Is Not Met</span>
    <pdq-button
      [icon]="previewingNotMet() ? 'preview_eye' : 'preview_eye_crossed'"
      variant="ghost"
      plain="true"
      size="medium"
      [iconColor]="previewingNotMet() ? 'var(--primary-default)' : 'var(--on-surface-light)'"
      (onClick)="previewMet(false)"></pdq-button>
  </div>
  <rich-textarea
    [initialContent]="goal.controls.messageWhenNotMet.value"
    (contentChange)="onMessageWhenNotMetChange($event)"
    [enableLinkInsert]="true"
    [placeholder]="notMetDefaults[minimumThresholdType.value]"></rich-textarea>
  @if (minimumThresholdType.value === 'item_count') {
    <span class="field__hint"
      >Use the tag {{ '{items-left}' }} to dynamically display the # of items left to reach the threshold</span
    >
  } @else {
    <span class="field__hint"
      >Use the tag {{ '{amount-left}' }} to dynamically display the $ amount left to reach the threshold</span
    >
  }
</div>

<div class="field">
  <div class="message-header">
    <span class="field__label message-header__label">Message Displayed When Goal Is Met</span>
    <pdq-button
      [icon]="previewingMet() ? 'preview_eye' : 'preview_eye_crossed'"
      variant="ghost"
      plain="true"
      size="medium"
      [iconColor]="previewingMet() ? 'var(--primary-default)' : 'var(--on-surface-light)'"
      (onClick)="previewMet(true)"></pdq-button>
  </div>
  <rich-textarea
    [initialContent]="goal.controls.messageWhenMet.value"
    (contentChange)="onMessageWhenMetChange($event)"
    [enableLinkInsert]="true"
    placeholder=""></rich-textarea>
  @if (minimumThresholdType.value === 'item_count') {
    <span class="field__hint"
      >Use the tag {{ '{items-left}' }} to dynamically display the # of items left to reach the threshold</span
    >
  } @else {
    <span class="field__hint"
      >Use the tag {{ '{amount-left}' }} to dynamically display the $ amount left to reach the threshold</span
    >
  }
</div>
